import Base from './base';

export default class Shops extends Base {
  resource = '/shops';
}

